const ShownSubPanelsEnum =
{
    None:'None',
    EditItem: 'EditItem',
    StatusUpdate:'StatusUpdate',
    Details:'Details',
};

export default ShownSubPanelsEnum;